import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  lastUpdatedFromShopify: {
    defaultMessage: 'Last Updated from Shopify: {date}.',
    description: 'Products Grid Last Updated from Shopify label',
    id: 'F8hyfU',
  },
  editSyncSettings: {
    defaultMessage: 'Edit Sync Settings',
    description: 'Products Grid Edit Sync Settings link button',
    id: 'lqZbKk',
  },
});
